// extracted by mini-css-extract-plugin
export default {"reportWrapper":"Reports_reportWrapper__yGM51"};